import { gsap } from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(DrawSVGPlugin)

$('body').on('click', '#contact-form-modal-content button', function (e) {

  const path = $('.form-thank-you svg path')
  gsap.set(path, { drawSVG:"100% 100%" })

  let interval = setInterval(function () {
    if($('.form-thank-you').is(':visible')) {

      gsap.to(path, { drawSVG: "0% 100%", duration: 1.5, delay: 0.1, stagger: 0.1 })

      clearInterval(interval)
    }
  }, 100)


})
